import React, { FunctionComponent } from 'react'
import { Link } from 'react-router-dom'

import { subjectDetailPath } from '../../utils/paths'

export interface SubjectLinkProps {
  subjectId?: number | string | null
  children?: React.ReactNode
  className?: string
  newTab?: boolean
}

export const SubjectLink: FunctionComponent<SubjectLinkProps> = props => {
  if (!props.subjectId && !props.children) return null
  if (!props.subjectId) return <span>{props.children}</span>
  return (
    <Link
      to={subjectDetailPath(props.subjectId)}
      className={props.className}
      target={props.newTab ? '_blank' : '_self'}
      title="Zobrazit detail subjektu"
    >
      {props.children || 'Detail subjektu'}
    </Link>
  )
}
